<template>
  <div>
    <CustomCollaspe
      class="filter-collapse on-sale"
      :collapse-id="'on-sale-collapse-1'"
      :collapse-header="'On sale in'"
    >
      <CustomRadio
        class="checkbox-grid"
        :options="currenciesOptions"
        :pre-selected="defaultCurrency"
        @selectRadio="updateSelected"
      />
    </CustomCollaspe>
  </div>
</template>

<script>
import CustomCollaspe from '@/components/BaseComponents/CustomCollapse.vue';
import CustomRadio from '@/components/BaseComponents/CustomRadio.vue';
import config from '@/config';

export default {
  components: {
    CustomCollaspe,
    CustomRadio
  },
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      currenciesOptions: [],
      defaultCurrency: ''
    };
  },
  watch: {
    defaultCurrency() {
      this.$emit('update:data', {
        ...this.data,
        currency: this.defaultCurrency
      });
    },
    data: {
      handler() {
        this.defaultCurrency = this.data.currency || config.defaultCurrency.address;
      },
      deep: true,
      immediate: true
    }
  },
  created() {
    this.currenciesOptions = config.supportCurrencies.map(currency => {
      return {
        name: currency.symbol,
        item: currency.address
      };
    });
    this.defaultCurrency = config.defaultCurrency.address;
  },
  methods: {
    updateSelected(value) {
      this.defaultCurrency = value;
    }
  }
};
</script>
